import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, space } from '../../theme/tokens';

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  padding: ${space['space-400']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${radius('card', 'radius-md')};

  &[data-disabled='true'] {
    opacity: 0.5;
  }

  &[data-no-timeslots='true'] {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;

export const DropdownColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
  min-width: 0;
`;

export const ErrorRow = styled.div`
  margin-top: ${space['space-100']};
`;

export const NoticeRow = styled.div`
  margin-top: ${space['space-400']};

  > * {
    margin-block: 0;
  }
`;
